import { ContainerModule } from '@evertel/di'


export const DI_WEB_DEPARTMENT_MODULE = [
    // DepartmentUsersListController moved to @evertel/admin
]
